var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkRedact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8C8.22386 8 8 8.22386 8 8.5V15.5C8 15.7761 8.22386 16 8.5 16H15.5C15.7761 16 16 15.7761 16 15.5V8.5C16 8.22386 15.7761 8 15.5 8H8.5ZM13.2374 14.2981L12.0001 13.0607L10.7626 14.2982L9.7019 13.2375L10.9394 12.0001L9.7019 10.7626L10.7626 9.7019L12.0001 10.9394L13.2374 9.70201L14.2981 10.7627L13.0607 12.0001L14.2981 13.2374L13.2374 14.2981Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4778 18.2034C21.6137 18.0674 21.5427 17.8348 21.354 17.798L17.2862 17.0046C17.119 16.972 16.972 17.119 17.0046 17.2862L17.798 21.354C17.8348 21.5427 18.0674 21.6138 18.2034 21.4778L19.0255 20.6557C19.1192 20.562 19.2712 20.562 19.365 20.6557L20.6389 21.9297C20.7327 22.0234 20.8847 22.0234 20.9784 21.9297L21.9297 20.9784C22.0234 20.8847 22.0234 20.7327 21.9297 20.6389L20.6557 19.365C20.562 19.2712 20.562 19.1192 20.6557 19.0254L21.4778 18.2034Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H9V5H7V3Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5V9H3V7Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5C3 3.89543 3.89543 3 5 3V5H3Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5V13H3V11Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H5V17H3V15Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H5V21C3.89543 21 3 20.1046 3 19Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19H9V21H7V19Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H13V21H11V19Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13V5H11V3Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H17V5H15V3Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3C20.1046 3 21 3.89543 21 5H19V3Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7H21V9H19V7Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H21V13H19V11Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkRedact);
export default __webpack_public_path__ + "static/media/mark-redact.6ccb5b73ff8fa8476e55a18a356035d8.svg";
export { ForwardRef as ReactComponent };